import {
  BreakPointCondition,
  UI,
  useBreakpointIf,
  HStack,
  Stack,
  VStack,
} from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import React from 'react';

export interface PaidCustodyHeadItemProps {
  label: string;
  value: string;
  tooltip?: string;
  isMobile?: boolean;
}

export const PaidCustodyHeadItem: React.FC<PaidCustodyHeadItemProps> = ({
  label,
  value,
  tooltip,
  isMobile,
}) => {
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  if (isMobile) {
    return (
      <HStack justifyContent="space-between" space={Spacing['inline.quarck']}>
        <HStack space={Spacing['inline.quarck']}>
          <UI.Text>{label}</UI.Text>
          {!!tooltip && (
            <UI.Tooltip label={tooltip} maxW="236px" openAsAccordionExpanded={isTablet}>
              <Stack>
                <UI.Icon name="Info" size="xxxs" color={Color['brand.primary.principal']} />
              </Stack>
            </UI.Tooltip>
          )}
        </HStack>
        <UI.Text variant="semibold">{value}</UI.Text>
      </HStack>
    );
  }

  return (
    <VStack space={Spacing['stack.quarck']}>
      <HStack space={Spacing['inline.quarck']}>
        <UI.Text variant="semibold">{label}</UI.Text>
        {!!tooltip && (
          <UI.Tooltip label={tooltip} maxW="236px" openAsAccordionExpanded={isTablet}>
            <Stack>
              <UI.Icon name="Info" size="xxxs" color={Color['brand.primary.principal']} />
            </Stack>
          </UI.Tooltip>
        )}
      </HStack>
      <UI.Text>{value}</UI.Text>
    </VStack>
  );
};
